import ListingCustomers from "../../Components/Customers/ListingCustomers";

export default function Listing(){
    return(
        <ListingCustomers/>
    )
}